module.exports = __webpack_public_path__ + "e9.no2.a5a7c466.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e9.no2.jpg
// module id = EMBq
// module chunks = 0